import { useTheme } from "@emotion/react";
import { Box, darken, IconButton, Typography } from "@mui/material";
import React from "react";

export const BotonDePago = ({ nombre, icono, onclick, sizeIcon, isSelected = false, isDisabled = false }) => {
  const theme = useTheme();
  const size = 150;
  
  const getStyleButton = () => {
    if (isDisabled) {
      return {
        backgroundColor: "#f5f5f5",
        color: "#cccccc",
        borderRadius: "20px",
        opacity: 0.5,
        cursor: "not-allowed",
        border: "2px solid #bdbdbdff",
      };
    }
    
    if (isSelected) {
      return {
        backgroundColor: "#fff",
        color: theme.bandera.colorSecundario,
        borderRadius: "20px",
        border: `3px solid ${theme.bandera.colorSecundario}`,
        boxShadow: `0 0 10px rgba(${parseInt(theme.bandera.colorSecundario.slice(1, 3), 16)}, ${parseInt(theme.bandera.colorSecundario.slice(3, 5), 16)}, ${parseInt(theme.bandera.colorSecundario.slice(5, 7), 16)}, 0.3)`,
        "&:hover": {
          backgroundColor: "#fff",
        },
      };
    }
    
    return {
      backgroundColor: "#fff",
      color: theme.bandera.colorSecundario,
      borderRadius: "20px",
      border: "2px solid #bdbdbdff",
      "&:hover": {
          backgroundColor: "#fff",
      },
    };
  };

  const styleButton = getStyleButton();

  // Función para renderizar el icono correctamente
  const renderIcon = () => {
    const iconColor = isDisabled ? "#cccccc" : theme.bandera.colorSecundario;
    
    // Si el icono es una string (ruta de imagen)
    if (typeof icono === 'string') {
      return (
        <img 
          src={icono} 
          alt={nombre || "Método de pago"}
          style={{
            width: `${sizeIcon}px`,
            height: `${sizeIcon}px`,
            objectFit: 'contain',
            filter: isDisabled ? 'grayscale(100%)' : 'none',
            opacity: isDisabled ? 0.5 : 1,
          }}
        />
      );
    }
    // Si el icono es un componente React (Material-UI icon)
    return React.cloneElement(icono, { 
      style: { 
        fontSize: '80px',
        color: iconColor 
      } 
    });
  };

  return (
    <Box
      onClick={isDisabled ? undefined : onclick}
      sx={{
        display: "flex",
        flexDirection: "grid",
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        width: "100%",
        height: "120px",
        
        padding: 2,
        ...styleButton,
        '&:hover': !isDisabled ? styleButton['&:hover'] : {},
      }}
    >
      <Box
        sx={{
          width: `${size}px`,
          height: `${size}px`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: nombre ? 1 : 0,
        }}
      >
        {renderIcon()}
      </Box>
      {nombre && (
        <Typography
          variant="body2"
          sx={{
            color: isDisabled ? "#cccccc" : theme.bandera.colorSecundario,
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 18,
            userSelect: 'none', // Evitar selección de texto
          }}
        >
          {nombre}
        </Typography>
      )}
    </Box>
  );
};
